
import { Component } from '@angular/core';

@Component({
    selector: 'app-nav-new-tab',
    templateUrl: './nav-new-tab.component.html',
    styleUrls: ['./nav-new-tab.component.scss']
})
export class NavNewTabComponent {
}
